<template>

  <div class="container-fluid mt-2">
    <div class="chart-container mt-3" v-if="selectedType && chartData.labels.length">
      <CChartPie
          class="chart-pie"
          :datasets="[chartData.dataset]"
          :labels="chartData.labels"
          :options="chartOptions"
      />
    </div>

    <DashboardTotal class="mt-4"/>
    <!-- Year and Candidate Type Dropdowns -->
    <CCard class="bg-style2 mt-4">

      <CCardBody>
        <CRow class="mb-3 align-items-end">
          <!-- Year Dropdown -->
          <CCol md="6">
            <label class="text-uppercase font-weight-bold mb-1 "style="font-size: 0.85rem">Select Year</label>
            <select class="form-control form-control-md" v-model="selectedYear">
              <option v-for="year in yearOptions" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </CCol>

          <!-- Candidate Type Dropdown -->
          <CCol md="6">
            <label class="text-uppercase font-weight-bold mb-1" style="font-size: 0.85rem">Select Candidate Type</label>
            <select class="form-control form-control-md" v-model="selectedType">
              <option value="">Select type</option>
              <option
                  v-for="type in typeOptions"
                  :key="type._id"
                  :value="type.type_name"
              >
                {{ type.type_name }}
              </option>
            </select>
          </CCol>
        </CRow>
      </CCardBody>

    </CCard>

    <!-- Dashboard & Table -->
    <TableVote class="mt-4" :selectedType="selectedType" :selectedYear="selectedYear" />
  </div>
</template>

<script>
import { CChartPie } from '@coreui/vue-chartjs'
import TableVote from '@/projects/views/score/components/table.vue'
import DashboardTotal from '@/projects/views/score/components/dashboard.vue'
import api from '@/service/api.js'

export default {
  name: 'CChartPieExample',
  components: {
    DashboardTotal,
    CChartPie,
    TableVote,
  },
  data() {
    return {
      selectedType: '',
      selectedYear: new Date().getFullYear(),
      typeOptions: [],
      yearOptions: [],
      allVoteData: [],
      chartData: {
        labels: [],
        dataset: {
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#4BC0C0',
            '#9966FF',
            '#FF9F40',
            '#999999',
            '#D0F4DE'
          ],
          data: []
        }
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right',
            labels: {
              color: '#343a40',
              font: {
                size: 14,
                weight: 'bold'
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return `${context.label}: ${context.raw}%`
              }
            }
          }
        }
      }
    }
  },
  watch: {
    selectedType() {
      this.generateChart()
    },
    selectedYear() {
      this.generateChart()
    }
  },
  methods: {
    async fetchTypes() {
      const res = await api.type('get')
      this.typeOptions = res.data.data || []
    },
    generateYearOptions() {
      const current = new Date().getFullYear()
      for (let i = 0; i < 5; i++) {
        this.yearOptions.push(current - i)
      }
    },
    async fetchVotes() {
      const res = await api.vote('getVoteCounts')
      this.allVoteData = res.data.data || []
      this.generateChart()
    },
    generateChart() {
      // Map type_name (selectedType) to its actual ObjectId (_id)
      const matchedType = this.typeOptions.find(t => t.type_name === this.selectedType)
      const matchedTypeId = matchedType?._id || null
      const year = Number(this.selectedYear)

      const block = this.allVoteData.find(b =>
          b.type === this.selectedType && b.year === year

    )

      if (!block) {
        this.chartData.labels = []
        this.chartData.dataset.data = []
        return
      }

      const total = block.candidates.reduce((sum, c) => sum + c.votes, 0) + (block.abstention || 0)
      const labels = block.candidates.map(c => c.name)
      const data = block.candidates.map(c =>
          total ? ((c.votes / total) * 100).toFixed(2) : 0
      )

      if (block.abstention > 0) {
        labels.push('Abstention')
        data.push(((block.abstention / total) * 100).toFixed(2))
      }

      this.chartData.labels = labels
      this.chartData.dataset.data = data
    }
  },
  async mounted() {
    await this.fetchTypes()
    await this.fetchVotes()
    this.generateYearOptions()
  }
}
</script>

<style scoped>
.chart-container {
  max-width: 80%;
  margin: 0 auto;
  height: 350px;
}

.chart-pie {
  width: 100%;
  height: 100%;
  display: block;
}

@media (max-width: 768px) {
  .chart-container {
    max-width: 90%;
    height: 300px;
  }
}

@media (max-width: 576px) {
  .chart-container {
    max-width: 100%;
    height: 250px;
  }
}
select {
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg width='10' height='7' viewBox='0 0 10 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23333' stroke-width='2'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 0.65rem;
  padding-right: 2.5rem; /* เผื่อช่องให้ไอคอนลูกศร */
  appearance: none;
  -webkit-appearance: none; /* Safari */
  -moz-appearance: none;    /* Firefox */
}

</style>
